import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {ConnectorListComponent} from '../diagram-render/shapes/connector-shape/connector-list/connector-list.component';
import {MaterialModule} from '../material.module';
import {SpinnerComponent} from './spinner/spinner.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MaterialModule, SpinnerComponent, ConnectorListComponent]
})
export class CoreModule {}
